import React from "react";
import CardUI from "../CardUI";


import "./Projects.css";

const Projects  = function() {

  const data = [
    {
      img: "img/paohvis_got_zoom.png",
      img_link: "paoh/paoh.html?url=https://www.aviz.fr/wiki/uploads/Research/GOT.csv",
      title: "PaohVis",
      description: "PaohVis is an interactive tool with a highly readable representation of dynamic hypergraphs without overlaps.",
      project_page: "https://www.aviz.fr/Research/Paohvis",
      demo: "paoh/paoh.html",
      technologies: ["web canvas", "dart", "python"],
    },
    {
      img: "img/pubs/pkclustering.png",
      title: "Pk-Clustering",
      description: "Interactive tool to help social scientists create meaningful clusters in social networks.",
      project_page: "https://www.aviz.fr/Research/Pkclustering",
      demo: "paoh/paoh.html",
      technologies: ["web canvas", "dart", "python", "flask"],
    },
    {
      img: "img/siion.png",
      title: "Siion",
      description: "Visualize a ranking of commercial areas (business districts) with greater potential to ensure the commercial success of a new business.",
      project_page: "https://visibilia.net.br/en/siion/",
      demo: "https://siion.visibilia.net.br/",
      technologies: ["mapbox-gl", "javascript", "react", "python"],
    },
    {
      img: "img/matrix_vistorian.png",
      title: "Adjacency matrix visualization",
      description: "Interactive matrix visualization for the Vistorian, an online platform that provides interactive visualization for various kinds of networks.",
      technologies: ["webgl", "typescript"],
      project_page: "https://github.com/networkcube/networkcube",
      demo: "https://vistorian.net/"
    },
    {
      img: "img/pubs/waviz_ui.png",
      title: "Spatio-temporal analysis",
      description: "Interactive tool to find anomalies and interesting patterns in spatio-temporal data.",
      project_page: "https://github.com/paolavaldivia/waviz.git",
      demo: "https://paolavaldivia.github.io/waviz/",
      technologies: ["d3", "javascript", "matlab"],
    },
    {
      img: "img/screenshot_low.png",
      title: "Data denoising",
      description: "Interactive data denoising using graph signal processing.",
      project_page: "https://github.com/paolavaldivia/gsp_vis_data",
      technologies: ["d3", "javascript", "react", "python", "flask"],
    },
    {
      img: "img/dyn_wav_ui.png",
      title: "Network analysis",
      description: "Interactive tool to analyze dynamic networks based on the graph wavelet transform",
      project_page: "https://github.com/paolavaldivia/dynnet_wavelet.git",
      demo: "https://paolavaldivia.github.io/dynnet_wavelet/",
      technologies: ["d3", "javascript", "angular", "python"],
    },
  ];

  const projects = data.map((pub, i) => {
    return (
        <span key={i}>
            <div className="w-100 w-sm-25 p-5 h-100">
              <CardUI title={pub.title}
                      imgsrc={pub.img}
                      imglink={pub.img_link || pub.img}
                      description={pub.description}
                      demo={pub.demo}
                      page={pub.project_page}
                      technologies={pub.technologies}
              />
            </div>
          </span>
    );
  });

  return (
      <div className="main-content projects container-fluid d-flex flex-wrap justify-content-center h-100 align-content-around">
        {projects}
      </div>
  );
}

export default Projects;



// WEBPACK FOOTER //
// ./src/Projects/Projects.js